export const RSA_KEYS = {
    publicKey: '-----BEGIN PUBLIC KEY-----\n'+
    'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKZ8YQ2VlOMlJO8Sdo0Y5j31UedjS+Pc\n'+
    'Y4Ttuw4l8yK7+HfMYyo8s/nG4qRnFJYaLGEzM27NZCBuaIlPVS9xVO8CAwEAAQ==\n'+
    '-----END PUBLIC KEY-----'
}